
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: 'Umtauschen',
    bba: 'Währungskonto',
    hy: 'Vertrag',
    jg: 'Eintauschen',
    hya: 'Vertragskonto'
  },
  index: {
    h24: '24-Stunden-Volumen',
    header_title: ['Wählen Sie den Handel mit digitalen Vermögenswerten ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Schließen Sie die Blockchain-Transaktion für digitale Vermögenswerte aus einer Hand ab',
    header_msg: 'Sicher-stabil-vertrauenswürdig',
    register_title: 'Registrieren ' + window.GLOBAL.LANG_TITLE.zh + ' Globales Konto beginnt Handelsreise',
    register_pl: 'Bitte geben Sie Ihre E-Mail oder Handy ein',
    register: 'Registrieren',
    featureTitleWhy:'Warum uns wählen',
    featureTitle:'Sicher · Stabil · Zuverlässig',
    featureMsg: '',
    featureList: [
      {icon: icon1, title:'Secure Wallet Technology', msg: ['Die Cold- und Hot-Wallet-Technologie wurde vom weltbesten Sicherheitsteam entwickelt und es gab noch nie einen Vorfall mit Münzverlusten. ',''] },
       {icon: icon2, title:'reiches Krypto-Asset-Geschäft', msg: ['Unterstützung von Spot- und Mehrfachderivat-Transaktionen usw. ist Ihr persönlicher Verwalter in der Welt der Krypto-Assets. ',''] },
       {icon: icon3, title:'Kunden auf der ganzen Welt verteilt', msg: ['Für Benutzer in mehr als 130 Ländern oder Regionen auf der ganzen Welt bieten wir eine vollständige Palette von Diensten für verschlüsselte Assets. ','']}
    ],
    bannerList: [
      {icon: banner01,title: "Verpflichtet, branchenführende Sicherheit und Stabilität zu bieten", msg: ["intelligente Verträge zum Schutz der Sicherheit von Anlegern", "reale Handelsleistung", "24-Stunden-Servicegarantie"] },
      {icon: banner02,title: "Ich möchte durch einfache Operationen sofort kaufen und verkaufen", msg: ["einfacher Handelsbildschirm", "wird sofort in Ihrem Kontostand angezeigt", "die meisten Kryptowährungen können gehandelt werden" ] },
      {icon: banner03,title: "Ich möchte durch Settlement-Kontrakthandel aktiv Gewinne erwirtschaften", msg: ["Gleichzeitig Konto eröffnen", "Strategische Anlage für eine Vielzahl von Trading-Futures", "Sie können 24 handeln Stunden am Tag, 365 Tage im Jahr, auch am Wochenende"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["Verwendung der Eigenschaften von Blockchain und Smart Contracts, Realisierung der Transaktionsleistung in der Kette und Verwendung von Smart Contracts, um die Sicherheit der Vermögenswerte der Anleger zu gewährleisten",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["Mit den diversifizierten Strategien der besten quantitativen Handelsexperten haben Sie die freie Wahl",""] },
      {icon: icon1_03, title: "Risk Grading", msg: ["Gestalten Sie diversifizierte Anlageprodukte basierend auf den unterschiedlichen Risiken und Vermögensverwaltungspräferenzen jedes Anlegers und beseitigen Sie effektiv Anlageschwellen", ""] },
      {icon: icon1_04, title: "Diversified Products", msg: ["Verschiedene Arten von Benutzerinvestitionsbedürfnissen und flexible Plattformmechanismen bereitstellen und weiterhin innovative Finanzdienstleistungen produzieren, die besser sind als der Markt", ""]}
    ],
    featureTitle2:'Multi-Plattform-Terminal-Transaktion jederzeit und überall',
    featureMsg2:'Abdecken von iOS und Android auf mehreren Plattformen, Unterstützung aller Geschäftsfunktionen',
    tab: ['Mainstream-Währung', 'Liste der Erhöhungen rund um die Uhr'],
    thead: ['Name','Neuster Preis','Höchster Preis des Tages','Niedrigster Preis des Tages','Aufsteigende Liste', '24H Volumen','Operation'],
    more:'Mehr anzeigen >',
    btn:'Transaktion',
    DealsTitel:'Handelsservice aus einer Hand',
    dealsTab:[
      { title: 'Umtauschen', content: 'Der Devisenhandel dient dem Austausch zwischen digitalen Vermögenswerten, wobei USDT als Bewertungseinheit für den Kauf anderer Währungen verwendet wird.'+window.GLOBAL.LANG_TITLE.zh+'Währungstransaktionen unterstützen Echtzeittransaktionen von digitalen Assets wie Bitcoin, Ethereum und Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Vertrag', content: 'Ein Finanzderivat einer digitalen Währung unterstützt nicht nur die Wahl zwischen dem Kauf von Long- oder Short-Selling-Kontrakten, um Einnahmen zu erzielen, sondern ist auch einfach zu bedienen und läuft nie ab.'+window.GLOBAL.LANG_TITLE.zh+'Der Vertrag verfügt über ein fortschrittliches Risikomanagementsystem mit bis zu 100-facher Hebelwirkung.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Optional', 'Vertrag', 'Münzen'],
    thead: ['Währung','Neuester Preis', '24H-Änderung', '24H-Niedrigster', '24H-Höchster', '24H-Volumen','Operation'],
    nodata: 'Keine Daten'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Über uns",
        dd: [{title: "Firmenprofil", ID: 1 }, { title: "Hilfezentrum", type:'help'}]
      },
      {
        dt: "Benutzer-Support",
        dd: [
          {title: "Benutzervereinbarung", ID: 3 },
          {title: "Datenschutzerklärung", ID: 5}
        ]
      },
      {
        dt: "kontaktiere uns",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["Einloggen", "Registrieren", "Anlagenmanagement","Lade App herunter"],
    nav: [
      { title: "Startseite", path: "/index",name: 'index' },
      { title: "Markt", path: "/market",name: 'market' },
      // { title: "Umtauschen", path: "/deal", name: 'deal'},
      // { title: "Vertrag", path: "/deal_c", name: 'deal_c' },
      { title: "Eintauschen", path: "/deal_jg", name: 'deal_jg' },
      { title: "Halterabatte", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "Meine Assets", path: "/asset" }],
    menus: [
      { icon: langzh, title: "Benutzercenter", path: "/setting" },
      { icon: langen, title: "austragen" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "Download"
  },
  // 登录
  login: {
    login: 'Bitte einloggen',
    msg: 'Bitte geben Sie Ihr registriertes Konto ein',
    list: ['Mobil/E-Mail','Passwort','Passwort vergessen?','Anmelden','Kein Konto, jetzt registrieren'],
    message: 'Konto oder Passwort dürfen nicht leer sein'
  },
  register: {
    dl: ['Über Mobiltelefon registrieren', 'Über E-Mail registrieren'],
    title: 'Registrieren Sie einen Account',
    country:'Nationalität',
    country_info:'Nationalitätsinformationen können nach der Registrierung nicht geändert werden, bitte wählen Sie wahrheitsgemäß',
    account: 'Kontonummer',
    code_text: 'Verifizierungs-Schlüssel',
    code_btn: 'CAPTCHA erhalten',
    code_unit: 's',
    code_no_data: 'Bestätigungscode muss ausgefüllt werden',
    password_text: 'Passwort eingeben',
    password_again_text: 'Passwort erneut eingeben',
    pid_text: 'Einladungscode',
    pid_pl: 'Optional',
    invitation_code_no_data:'Einladungscode ist erforderlich',
    xy:'Benutzervereinbarung',
    xy_no_checked:'Bitte wählen Sie das Protokoll aus',
    agree:'Ich habe gelesen und zugestimmt',
    register_btn:'Registrieren',
    bz: ['Nationalitätsinformationen können nach der Registrierung nicht geändert werden, bitte achten Sie darauf, dass Sie wahrheitsgemäß wählen. ','Die Bestätigungs-E-Mail wird möglicherweise fälschlicherweise als Spam eingestuft, bitte überprüfen Sie sie sorgfältig. ','Bitte bewahren Sie Ihr Konto richtig auf' + window.GLOBAL.LANG_TITLE.zh +'Konto und Login-Passwort. ','Verwenden Sie nicht dasselbe Login-Passwort wie bei anderen Websites. '],
    account_no_data: 'Konto darf nicht leer sein',
    code_no_equality: 'Bestätigungscodes sind nicht gleich',
    password_no_data: 'Passwort darf nicht leer sein',
    password_no_equality: 'Die beiden Passwörter sind nicht gleich'
  },
  // 设置密码
  bindmpwd: {
    title: 'Passwort festlegen',
    account: 'Kontonummer',
    code_text: 'Verifizierungs-Schlüssel',
    code_btn: 'CAPTCHA erhalten',
    code_unit: 's',
    password_text: 'Passwort eingeben',
    password_again_text: 'Passwort erneut eingeben',
    code_no_data: 'Bestätigungscode muss ausgefüllt werden',
    code_no_equality: 'Bestätigungscodes sind nicht gleich',
    password_no_data: 'Passwort darf nicht leer sein',
    password_no_equality: 'Die beiden Passwörter sind nicht gleich',
    bindmpwd_btn: 'Bestätigen',
    phone_no_data: 'Telefonnummer darf nicht leer sein',
    password_login_text: 'Bitte geben Sie Ihr Login-Passwort ein',
    password_trade_text: 'Passwortlänge 6 Ziffern',
    password_again_tarde_text: 'Passwortlänge 6 Ziffern',
  },
  // 忘记密码
  forgetpwd: {
    title: ['Passwort ändern', 'Passwort vergessen'],
    account: 'Kontonummer',
    code_text: 'Verifizierungs-Schlüssel',
    code_btn: 'CAPTCHA erhalten',
    code_unit: 's',
    password_text: 'Passwort eingeben',
    password_again_text: 'Passwort erneut eingeben',

    phone_no_data: 'Telefonnummer darf nicht leer sein',

    account_no_data: 'Konto darf nicht leer sein',
    code_no_data: 'Bestätigungscode muss ausgefüllt werden',
    code_no_equality: 'Bestätigungscodes sind nicht gleich',
    password_no_data: 'Passwort darf nicht leer sein',
    password_no_equality: 'Die beiden Passwörter sind nicht gleich',
    forgetpwd_btn: 'Bestätigen'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Handynummer binden',
    phone_text: 'Telefonnummer',
  },
  person: {
    more: 'Mehr laden',
    no_more: 'Keine Daten mehr',
    index_center:"Benutzercenter",
    index_menus: [
      { icon: zhsz, title: "Kontoverwaltung", path: '/setting' },
      { icon: sfrz, title: "KYC-Authentifizierung", path: '/sfyz' },
      { icon: sfrz, title: "Junior-Zertifizierung", path: '/smauth' },
      { icon: sfrz, title: "Verifiziert", path: '/seniorauth' },
      { icon: jtrz, title: "Adressauthentifizierung", path: '/dzrz' },
      { icon: jtrz, title: "Crypto kaufen", path: '/kjmbSelect' },
      { icon: jtrz, title: "Kreditwürdigkeit", path: '/credit' },
      { icon: jtrz, title: "Aufzeichnungen", path: '/deallog' },
      { icon: jtrz, title: "Aufzeichung der Aufladungen", path: '/cbjl' },
      { icon: jtrz, title: "Aufzeichnung der Abhebungen", path: '/tbjl' },
    ],
    cbtb: 'Einbezahlen & Abheben',
    jymx: 'Detail zur Transaktion',
    xyf: {
      'title': 'Kreditwürdigkeit',
      'pgsj': 'Auswertungszeit'
    },
    smrz:{
       title:'Verifiziert' ,
       sure_title:'Sie haben die Echtnamen-Authentifizierung bestanden',
       zj_type:'Zertifikatstyp',
       zj_info:['1, die Zertifizierungsinformationen können nach der Verifizierung nicht mehr geändert werden, bitte wahrheitsgemäß ausfüllen','2, die verifizierten Echtnameninformationen können nicht erneut zertifiziert werden'],
       zj_name:'Name',
       zj_num:'Dokumentnummer',
       zj_btn:'OK',
       zj_rebtn:'Erneut verifizieren',
       zj_sebtn:'Erweiterte Verifizierung',
       zj_type_array:[{name:'Personalausweis',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "Personalausweis"
        },
        {
            id: 2,
            name: "Pass"
        },
        {
            id: 3,
            name: "Führerschein"
        },
        {
            id: 4,
            name: "Aufenthaltsgenehmigung"
        },
        {
            id: 5,
            name: "Andere Arten von Ausweise"
        }
       ],
       zj_data:{city:'Nationalität darf nicht leer sein',type:'Anmeldeinformationstyp darf nicht leer sein',name:'Name darf nicht leer sein',zj_num:'Ausweisnummer darf nicht leer sein'},
       zsxm: 'Echter Name',
       qsrzsxm: 'Bitte Ihren echten Namen eingeb',
       zjlx: 'Art des gültigen Ausweises',
       qxzzjlx: 'Bitte Art von Anschrift wählen',
       sfz: 'Personalausweis',
       zjhm: 'Ausweisnummer',
       qsrzjhm: 'Bitte Ausweisnumemr eingeben',
       sczjz: 'Fotos des Ausweises hochladen',
       zjzm: 'Vorderseite des Ausweises hochladen',
       zjfm: 'Rückseite des Ausweises hochladen',
       qsczjzm: 'Bitte laden Sie das Vorderfoto Ihres Ausweises hoch',
       qsczjfm: 'Bitte laden Sie ein Foto von der Rückseite Ihres Ausweises hoch',
       scqmz: 'Dokumente zum Ausweis und persönliche Unterschrift hochladen',
       qscscqmz: 'Bitte laden Sie Ihren Ausweis und Ihr persönliches Unterschriftsfoto hoch',
       zj: [
         {
           id: 1,
           title: 'Personalausweis'
         },
         {
           id: 2,
           title: 'Pass'
         },
         {
           id: 3,
           title: 'Andere Arten von Ausweise'
         },
       ],
       tj: 'Einreichen',
       shz: 'Wird geprüft',
       shtg: 'Genehmigt'
    },
    gjrz:{
      title:'Senior-Zertifizierung',
      zj_info:['1. Es werden Bilder unterstützt, die kleiner als 8 MB sind und im JPG-, JPEG- oder PNG-Format vorliegen.','2. Die Fotos des Dokumente zum Ausweis müssen lesbar sein und dürfen nicht verändert oder gesperrt werden. Das persönliche Foto  und die Dokumentennummer und der Name des Dokumenteninhabers müssen deutlich sichtbar sein.','3. Die Fotos müssen ohne Kopfbedeckung aufgenommen werden und sollten keine Schminke enthalten. Die Gesichtszüge auf dem Foto sollten klar und deutlich erkennbar sein und die Arme sollten vollständig sichtbar sein.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Sicherheitseinstellungen',
      bind:[{bind_title:'Passwort zurückstellen',bind_name:'Briefkasten'},{bind_title:'Passwort zum Abheben einstellen',bind_name:'Briefkasten'}]
    },
    wdtg:{
      own_code:'专属邀请码',
      own_code_url:'专属邀请连接',
      own_push_title:'我的推广',
      own_push_content:['邀请总收入（估值）','邀请人数','人'],
      own_push_content_profit:['一级邀请收益','二级邀请收益','三级邀请收益','四级邀请收益'],
      own_push_content_num:['一级邀请人数','二级邀请人数','三级邀请人数','四级邀请人数'],
      own_push_profit_title: ['ID', '收益', '备注信息','添加时间'],
      own_push_num_title: ['ID', '名称', '电话','添加时间'],
    },
    jyzt_td: ['Zeit','Details','Betrag'],
    cbjl_td: ['Zeit','Währung','Menge','Status'],
    sfrz_txt: ['Identitätsauthentifizierung','Sie haben die Bewertung abgegeben, bitte warten Sie auf das Ergebnis','Sie haben die erweiterte Authentifizierung bestanden','Vorderseite des Personalausweises','Rückseite des Personalausweises','Authentifizierung','Authentifizierung fehlgeschlagen, Bitte authentifizieren Sie sich erneut'],

    zhsz_txt: ['Ihre Kontosicherheitsstufe: #','Ihre Kontosicherheitsstufe: #, mehr Informationen verbessern und die Kontosicherheit gewährleisten'],
    zhsz_m:'stark',
    zhsz_n:'schwach',
    zhsz_p:'unsicher',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Login-Passwort', value: 'Es besteht die Gefahr, dass Internetkonten gestohlen werden. Es wird empfohlen, Ihr Passwort regelmäßig zu ändern, um die Sicherheit Ihres Kontos zu gewährleisten.',value2:'', btn: 'Ändern',bind_email:'Bitte binden Sie zuerst Ihre E-Mail oder Ihr Handy', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Passwort für Transaktionen', value: 'Passwort festlegen', btn: 'Gehe zum Set', path: '/bindmpwd' }
    ],
    sksz_txt: ['Empfangseinstellungen','Speichern'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Startseite',
    prev:'Vorherige Seite',
    next:'Nächste Seite',
    last:'Letzte Seite',
    no_data: 'Keine Daten',
  },
  asset: {
    title: 'Meine Assets',
    zjhz: 'Überweisung',
    cb: 'Währung aufladen',
    gz: 'USDT-Bewertung',
    atnv: [],
    zh_title: 'Gesamtvermögen umgerechnet：',
    index_title: 'Vermögenswerte',
    address_title: 'Währung',
    address_txt: ['bitte auswählen', 'Adresse der Abhebung', 'Bitte Inhalt eingeben','Bemerkungen','Adressliste'],
    address_btn: ['Hinzufügen','Speichern','Löschen','Bearbeiten'],
    address_td: ['Währung', 'Adresse der Abhebung', 'Bemerkung', 'Bedienung'],
    currency_td: ['Währung', 'Verfügbar', 'Einfrieren', 'Konversion'],

    table_title: 'Bilanzsumme：',
    table_address_title: 'Abhebungsadressenverwaltung',
    table_td: ['Währung', 'Verfügbar', 'Einfrieren', 'Konversion', 'Bedienung'],
    table_btn: ['Währung aufladen', 'Währung abheben', 'Aufzeichnung', 'Transfer'],

    money_text: ['Adresse der Abhebung', 'bitte auswählen', 'Betrag', 'Verfügbar：', 'Gebühren',
      'Eingehender Betrag', 'Passwort für Transaktionen','Tag (Memo)','Minimum '],
    money_btn: 'Währung abheben',
    xzbz: 'Währung wählen',
    money_msg: ['Hinweis', '1. Auszahlungszeit ist 12:00-24:00 Uhr Hongkonger Zeit, und Sie können zwei Auszahlungsanträge pro Tag einreichen (die Mindestauszahlung beträgt 100u, die maximale Auszahlung beträgt 200.000u);', '2. Derzeit unterstützt die Auszahlung nur die USDT-Währung und der Wallet-Link-Typ wählt ERC20;','3. Nach dem Einreichen des Auszahlungsantrags befinden sich die Gelder in einem eingefrorenen Zustand, da die Auszahlung im Gange ist, und die Gelder befinden sich vorübergehend in der Verwahrung des Systems und können von Ihnen nicht frei kontrolliert werden. Dies bedeutet nicht, dass Sie den Vermögenswert verloren haben oder der Vermögenswert abnormal ist. Bitte warten Sie geduldig auf die Genehmigung im Prozess;','4. Nach dem Absenden des Widerrufsantrags richtet sich die Ankunftszeit nach der Sperrbestätigungszeit Ist der Widerruf nach der Widerrufsfrist nicht zu erwarten, wenden Sie sich bitte für Rückfragen an den Kundenservice;','5. Um Arbitrage zu verhindern, werden 90% des Gesamtverbrauchsbetrags benötigt, um eine Auszahlung einzuleiten'],

    recharge_title: 'Aufladeadresse',
    recharge_btn: ['Kopieren', 'QR-Code', 'Währung aufladen'],
    recharge_text: ['Betrag', 'Hinweis', 'Bitte hinterlegen Sie keine Nicht-USDT-Vermögenswerte an die oben genannte Adresse, andernfalls werden die Vermögenswerte nicht abgerufen.', 'USDT-Einzahlungen unterstützen nur die einfache Sendemethode. Einzahlungen mit anderen Methoden (alle senden) können vorübergehend nicht gebucht werden. Bitte haben Sie Verständnis.', 'Zertifikat', 'beschreiben(Optional)','Name der Kette'],

    record_title: 'Finanzunterlagen',
    record_td: ['Betrag', 'Aufzeichnung', 'Zeit'],

    transfer_title: 'Transfer',
    transfer_btn: ['Alle', 'Transfer'],
    transfer_text: ['Von', 'zu', 'Bitte geben Sie den Überweisungsbetrag ein', 'Verfügbar：'],
    "bq": "Tag (Memo)",
    "qsrbq": "Bitte das Tag eingeben",
    "yhktx": "Über Bankkarte abheben",
    "yhmc": "Bankname",
    "qsryhmc": "Bitte Bankname eingeben",
    "yhzh": "Bankkonto",
    "qsryhzh": "Bitte Bankkontonummer eingeben",
    "gjhkdm": "SWIFT-Code",
    "qsrgjhkdm": "Bitte SWIFT-Code eingeben",
    "yhdz": "Adresse der Bank",
    "qsryhdz": "Bitte Adresse der Bank eingeben",
    "skrxm": "Name des Zahlungsempfängers",
    "qsrskrxm": "Bitte Name des Zahlungsempfängers eingeben",
    "skrdh": "Telefon des Zahlungsempfängers",
    "qsrskrdh": "Bitte Telefon des Zahlungsempfängers eingeben",
    "skrdz": "Adresse des Zahlungsempfängers",
    "qsrskrdz": "Bitte Adresse des Zahlungsempfängers eingeben"
  },
  text: {
    btn:'zurück',
    login:'Bitte zuerst einloggen'
  },
  deal: {
    chooseType: 'Provisionsart',
    choose: 'bitte auswählen',
    balance: 'Saldo：',
    account: ['Konto', 'Verfügbar', '/Einfrieren', 'Transfer'],
    dir: ['Kaufen', 'Verkaufen'],
    dir2: ['Verfügbar', 'Vermarktbar'],
    cs: 'Optional',
    sxf: 'Gebühr',
    jye: 'Umsatz',
    sc_list: ['Markt','Name','erhöhter Preis'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['Währung', 'Aktuellster Pre', 'Erhöhen, ansteigen'],
    k_line_txt: ['≈', '', 'Erhöhen','Höchster Preis','Niedrigster Preis', '24-Stunden-Volumen'],
    tabListLTitle: ["Aktuelle Aufträge", "Kommission-Historie"],
    tabListLEntrust: ["Kaufen", "Verkaufen"],
    tabListRTitle: ["Grenzpreishandel", "Marktpreishandel"],
    table_btn: ['Abheben'],
    index_td_l: ['Zeit', 'Handelspartner', 'Betrag', 'Preis', 'Bedienung'],
    index_td_r: ['Aktuellster Pre', 'Richtung', 'Preis', 'Betrag'],
    index_td_r2: ['Letzte Transaktion', 'Zeit', 'Preis', 'Handelsvolumen'],
    table_txt: ['Abgeschlossen', 'Abgehoben'],

    db_1_txt: ['Verfügbar', 'Kaufpreis', 'Verkaufspreis', 'Volumen der Käufe', 'Verkaufsvolumen', 'Umsatz', 'Kaufen zum besten Marktpreis','Verkaufen zum besten Marktpreis','Hand kaufen','Hand verkaufen'],
    db_2_txt: ['Preis', 'Hebelwirkung', 'bitte auswählen', 'Lot', '1lot =', 'Lot', 'Vertragsmarktwert', 'Bonds', 'Kaufen zum besten Preis auf dem Markt','Verkaufen zum besten Preis auf dem Markt'],
    pathList: ['Vertragsdatensatz','Transaktionsdatensatz'],
    db_btn: ['Kaufen (lang)','Verkaufen (kurz)'],
    tabListLTitle2: ['Aktuelle Aufträge'],

    lt_btn: ['Ein-Klick-Liquidation', 'Stop-Gewinn- und Stop-Loss-Preis festlegen', 'Liquidation', 'Jetzt Absenden', 'Rückkehr'],
    lt_txt: ['Risikorate：', 'Gesamtprofit：'],
    lt_td: ['Typ','Hebelwirkung', 'Preis der Position', 'Aktueller Preis', 'Bonds', 'Take-Profit-Preis', 'Stop-Loss-Preis', 'Eröffnungszeit', '手数', 'Profit und Verlust', 'Bedienung'],
    lt_dl: ['Stop-Gewinn- und Stop-Loss-Preis festlegen', 'Take-Profit-Preis', 'Stop-Loss-Preis'],

    lt_0_btn: ['Abheben'],
    lt_0_td: ['Kontaktdetails', 'Währung', 'Betrag', 'Aktueller Preis', 'Gebühren', 'Bedienung'],

    lt_1_btn: ['Liquidation'],
    lt_1_txt: ['Wird geschlossen'],
    lt_1_td: ['Typ', 'Preis der Position', 'Aktueller Preis', 'Bonds', 'Take-Profit-Preis', 'Stop-Loss-Preis', 'Eröffnungszeit', 'Gebühren', 'Profit und Verlust', 'Bedienung'],
    node_data: 'Keine Daten',

    lt_3_txt: ['Abgeschloss', 'Liquidation'],
    lt_3_td: ['Typ', 'Lot', 'Preis der Position', 'Schlusskurs', 'Take-Profit-Preis', 'Stop-Loss-Preis', 'Bonds', 'Verfügbare Bonds', 'Eröffnungszeit', 'Schließzeit', 'Gebühren',
      'Profit und Verlust', 'Bedienung'],

    lt_4_txt: ['Abgehoben'],
    cm: ['Zeit der Ausgabe', 'Menge der Ausgabe', '流通总量', '总凑价格', 'Offizielle Webseite','Weißes Papier','Einführung'],
    qsrsl: 'Bitte Betrag eingeben',
    qsrss: 'Bitte geben Sie das Los ein',
  },
  notice:{
      notice_title:'Ankündigungszentrum',
  },
  bzhl:{
    title: 'Halterabatte',
    ttzbt: '天天赚不停',
    wdtg: 'Mein Hosting',
    zztgdzj: 'Hinterlegte Fonds',
    yjjrsy: 'Geschätzt täglich',
    ljsy: 'Einträge Insgesamt',
    tgzdd: 'Hinterlegte Bestellungen',
    tgdd: 'Hinterlegungs-Bestellung',
    t1: 'Risikoarmes und stabiles Finanzmanagement, bei Bedarf jederzeit einlösbar',
    t2: 'Ihr kostenloser Geldverwaltungsassistent',
    cljxcp: 'Produkt-Zyklus',
    dbxe: 'Single-Limit',
    rsyl: 'Ertrag(%)',
    rsyl2: 'Tägliche Gewinnrate：',
    zq: 'Zyklus',
    qmr: 'Geh einkaufen',
    ckgd: 'Mehr sehen',
    cpgk: 'Produktübersicht',
    pxsj: 'Auszahlungszeitpunkt der Dividente',
    tgzj: 'Kapital der Hinterlegung',
    tqsh: 'Vorzeitige Rückzahlung',
    cpld: 'Produkt-Highlights',
    cpgz: 'Produktregeln',
    cont: 'Der Ziegelumzug erfolgt durch das Hosten von USDT auf der Plattform, und das professionelle Team der Plattform führt das Recht aus, Ziegel zu bewegen. Die Teilnehmer können den Anteil der Plattform an den Einnahmen aus dem Ziegelumzug während der Fondsverwahrfrist erhalten, auf die jederzeit zugegriffen werden kann. was sicher und bequem ist.',
    zj: '100% Förderung',
    aqbz: 'Sicherheit',
    jjrsy: 'Einnahmen an Feirtagen',
    bjd: 'Ununterbrochen',
    cgcrh: 'Nach erfolgreicher Anzahlung',
    dtqx: 'Zinsenwert an diesem Tag',
    ljzr: 'Jetzt überweisen',
    xqglgj: 'Kostenlose Geldmanagement-Tools',
    ddh: 'Bestellungsnummer',
    tgje: 'Treuhandbetrag',
    tgsj: 'Zyklustage',
    yhl: 'Profitiert',
    xdsj: 'Bestellzeitpunkt',
    zt: 'Status',
    fh: 'Rückkehr',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx:'Anlagerisiko',
    shsc:'Einlösungszeit',
    di:'niedrig',
    yggzr:'Ein Arbeitstag',
    msgsxf:'Kostenlose Abonnementgebühr',
    mr: 'Täglich',
    dqfh: 'Rückerstattung wenn die Frist erreicht wird',
    ljgm: 'Jetzt kaufen',
    tgz: 'Wird hinterlegt',
    sh: 'Zurücknehmen',
    ywc: 'Abgeschlossen',
    ysh: 'Zurückgenommen',
    all: 'Alle',
    "xzbzts": "Einfach und sicher. Dividenden können in mehreren Währungen ausgewählt werden",
    "qtbz": "Andere Münzen"
  },
  pay:{
    qsrjymm:'Bitte 6-stelliges Transaktionspasswort eingeben',
    tbmmts:'Bitte gehen Sie zum Benutzercenter, um das Transaktionspasswort festzulegen',
  },
  tips:{
    qxztbdz:'Bitte geben Sie die Auszahlungsadresse ein',
    qsrtbsl:'Bitte geben Sie die Anzahl der Coins ein'
  },
  statusText: ['Fehlgeschlagen','Warten auf Verarbeitung','Erfolgreich'],
  dzrz: {
    title: 'Adressauthentifizierung',
    sdddz: 'Adresse der Stromrechnung',
    zdtpsc: 'Rechnungsbild hochladen',
    qsrsdddz: 'Sie müssen die Adressinformationen ausfüllen und die Stromrechnung oder die Breitbandadressrechnung einreichen',
    qsczdtp: 'Bitte lade ein Bild der Rechnung hoch',
    status: ['Genehmigt','Genehmigt'],
    qd: 'OK',
  },
  jgcc: {
    wtgd: 'Ausstehende Bestellung',
    cj: 'Deal',
    jj: 'Info',
    zc: 'Aktuell',
    lszc: 'Historie',
    qblx: 'Alle Arten',
    xj: 'Aktueller Preis',
    sj: 'Zeit',
    fx: 'Richtung',
    jg: 'Preis',
    sl: 'Betrag',
    jgsj: 'Liefezeit',
    gmj: 'Kaufpreis',
    jsj: 'Abrechnungspreis',
    yk: 'Profit und Verlust',
    xq: 'Details',
    mz: 'Lang kaufen',
    md: 'Kurz verkaufen',
    dqye: 'Aktuelles Saldo',
    gb: 'Schließen',
    jxxd: 'Weitere Bestellungen machen',
    qrxd: 'Bestätigen',
    ddqr: 'Bestätigung der Bestellung',
    sxf: 'Gebühr',
    kyye: 'Balance',
    jypz: 'Name',
    jyfx: 'Richtung',
    tzje: 'Preis des Investment',
    tzjeTips: 'Investitionsbetrag darf nicht 0 sein',
    dqsj: 'Verfallsdatum',
    jssj: 'Lieferzeit',
    gmsj: 'Kaufzeit',
    sy: 'Profit',
    zxje: 'Mindestbetrag ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Höchstbetrag ',
    qsrje: 'Bitte Betrag eingeben',
    zxtzje: 'Minimum ',
    yebz: 'Mangelhaftes Gleichgewicht',
    xq: 'Details',
    ddz: 'Warten',
    jgjl: 'Lieferschein',
    bz: 'Währung',
    cz: 'Bedienung'
  },
  kjmb: {
    title: 'Crypto kaufen',
    fzcg: 'Erfolgreich kopieren',
    ljmb: 'Crypto kaufen',
    lxkf: 'Kundenservice kontaktieren'
  },
  news: {
    title: 'Meine Nachricht',
    "gg": "Anküdigungen",
    ckxq: 'siehe Einzelheiten'
  },
  statusTabs:['Ausstehende Bestellung', 'Wird gehandelt','Abgeschloss', 'Abgehoben'],
  "chongzhi":{
    "zy": "Wichtig",
    "cbxx": "Token-Einzahlungsinformationen",
    "qsrsl": "Bitte geben Sie den Einzahlungsbetrag ein",
    "tips2": "1. Wallet/Plattform-Kompatibilität: Das heißt, das Netzwerk wird unterstützt; wenn die Zielplattform Ihr Auszahlungsnetzwerk nicht unterstützt, können die Vermögenswerte nicht abgerufen werden.",
    "tips3": "2. Ihr Aufladenetzwerk und die Zielplattform sind identisch: Wenn Sie als Zieladresse das Ethereum-Netzwerk wählen, die Aufladung jedoch die TRC20-Smart-Chain wählt, können Sie Ihre digitalen Assets möglicherweise nicht abrufen.",
    "tips4": "3. Vergewissern Sie sich vor dem Aufladen, dass Ihre Adresse und Ihr Betrag korrekt sind.",
    "tips5": " Zur Erinnerung: Aufgrund der Anonymität und Privatsphäre des Blocknetzwerks verlieren Sie bei der Eingabe falscher Informationen die entsprechenden Vermögenswerte. Bitte überprüfen Sie Ihre Aufladeadresse und Menge sorgfältig",
    "tips2_1": "• Bitte belasten Sie die obige Adresse nicht mit Vermögenswerten in anderen Währungen, da die Vermögenswerte sonst nicht abgerufen werden können.",
    "tips2_2": "• Die digitale Währung kann nicht rechtzeitig geliefert werden. Die tatsächliche Ankunftszeit hängt von der Bestätigungsgeschwindigkeit der Blockchain ab.",
    "tips2_3": "• Ihre Aufladeadresse wird sich nicht häufig ändern, Sie können aufladen; wenn es eine Änderung gibt, werden wir unser Bestes versuchen, Sie per Website-Ankündigung oder E-Mail zu benachrichtigen.",
  },
  "tibi":{
    "tbxx":"Informationen zum Widerruf",
    "qsrbq": "Bitte geben Sie ein Label ein",
    "tbTips1": "• Um die Sicherheit des Geldes zu gewährleisten, werden wir die Auszahlung manuell überprüfen, wenn sich Ihre Kontosicherheitsrichtlinien oder Ihr Passwort ändern. Bitte warten Sie geduldig, bis sich die Mitarbeiter telefonisch oder per E-Mail mit Ihnen in Verbindung setzen.",
    "tbTips2": "• Bitte stellen Sie sicher, dass Ihr Computer und Browser sicher sind, um zu verhindern, dass Informationen manipuliert oder durchgesickert werden.",
    "tbTips3": "• Der von Ihnen erwähnte digitale Vermögenswert ist ein Ein-Münzen-Mehrketten-Vermögenswert. Unabhängig davon, von welcher Kette Sie sich entscheiden, zu erhöhen, bedeutet dies, dass der Gesamtbetrag der digitalen Vermögenswerte, die auf Ihrer Auszahlungsseite angezeigt werden, reduziert wird. um den entsprechenden angehobenen Betrag .",
  },
  "gjlb": "Liste der länder.",
  "qxzgjlb": "Bitte wählen Sie Land / Region",
  "mbwt":{
    "title": "Einstellungen für Sicherheitsprobleme",
    "mbwt": "Sicherheitsprobleme",
    "problem":[
      {
        "id": 1,
        "title": "Was war dein bester Freund, als du ein Kind warst?"
      },
      {
        "id": 2,
        "title": "Wer ist dein Idol?"
      },
      {
        "id": 3,
        "title": "Wo ist dein sehnsüchtigster Ort?"
      }
    ],
    "qtxda": "Bitte fülle die Antwort aus",
    "qsrxmm": "Bitte geben Sie ein neues Passwort ein",
    "qqrmm": "Bitte Passwort bestätigen",
    "sydqmmcz": "Aktuelles Passwort zurücksetzen verwenden",
    "zhmm": "Sicherheitsprobleme Passwort abrufen",
    "ysz": "Wurde festgelegt",
    "tg": "über etwas springen",
    "tj": "einreichen",
    "zyts": "Wichtig:",
    "zytsCont": "Geben Sie die geheime Antwort und den Verifizierungscode nicht weiter und denken Sie an das Sicherheitsproblem, das Ihnen beim Abrufen Ihres Passworts hilft"
  },
  "zc":{
    "zclb": "Asset-Liste",
    "zczh": "Asset-Konvertierung",
    "yczc": "Assets, die Sie nicht haben, ausblenden"
  },
  "indexNew":{
    "t1": "Weltweit führend",
    "t2": "Digital Asset Service Platform",
    "t3": "Vollständige Blockchain-Transaktion für digitale Vermögenswerte aus einer Hand",
    "t4": "Mobilnummer/E-Mail",
    "t5": "Jetzt registrieren",
    "t6": "Willkommen Kunden aus der ganzen Welt durch GMO Global",
    "t7":"Entdecken und starten Sie ihre Verschlüsselungsreise"
  },
  "newReg":{
    "dl": ['Email','Mobiltelefon'],
    "cjzh": "Benutzerkonto erstellen",
    "sysjhzyx": "Mit Handynummer/E-Mail registrieren",
    "yhxy": "&lt;Benutzervereinbarung&gt;",
    "yhxy2": "Ich habe die &lt;Benutzervereinbarung&gt; gelesen und stimme ihnen zu",
    "yxgz": "Bitte geben Sie eine gültige Email-Adresse ein",
    "dhgz": "Die Handynummer ist falsch"
  },
  "indexNew2":{
    "t1": "Trade auf unsere Bestellung",
    "t2": "Bitbank verwenden",
    "t3": "Bitbank ist ein ausgeklügelter Austausch von Bitcoin und verschlüsselten Vermögenswerten. Es ist sehr einfach, bequem, sicher und leistungsstark. Es unterstützt Transaktionen auf mehreren Web- und Smartphone-Plattformen. Transaktionsdaten und Diagramme werden in Echtzeit aktualisiert. Umfassend Die Marktpreisanalyse bietet mehr als 60 technische Analysetools. Beginnen Sie mit dem Handel",
    "ksjy": "Starten Sie den Handel",
    "ly": "5 Gründe, sich für Bitbank zu entscheiden",
    "item1_t1": "Führendes Handelsvolumen",
    "item1_t2": "Nr. 1 * Handelsvolumen von Krypto-Assets",
    "item1_t3": "Hohe Liquidität, komfortables (angenehmes Handelserlebnis) Trading. Listen Sie 12 Arten von Krypto-Assets auf.",
    "item2_t1": "Hohe Fremdbewertung",
    "item2_t2": "Sichere Handelsumgebung",
    "item2_t3": "Verwenden Sie offline Cold Wallet. Verwenden Sie Multisig, um Hacker fernzuhalten. Schützen Sie Ihre Vermögenswerte mit Hightech",
    "item3_t1": "Einfache Bedienung und zuverlässige Anwendung",
    "item3_t2": "Einfache Bedienung und einfache Anwendung",
    "item3_t3": "Eine zuverlässige Anwendung mit umfangreichen Funktionen. Sie kann Handelsmöglichkeiten außerhalb der Transaktion aufrechterhalten.",
    "item4_t1": "Ganztägig geöffnet",
    "item4_t2": "Kann Gold einzahlen",
    "item4_t3": "24-Stunden-Einzahlungsunterstützung, auch an Feiertagen!",
    "item5_t1": "Smartphone und PC",
    "item5_t2": "Humanisiertes Design",
    "item5_t3": "Auch wenn Sie ein Smartphone verwenden, können Sie bedenkenlos einfache und qualifizierte Transaktionen durchführen",
    "aqkk": "Sicher und zuverlässig",
    "aqkk2": "Bitbank Bitcoin-Transaktion",
    "cjzh": "Konto erstellen",
  },
  "xbsg":{
    "title": "Neue Münze",
    "wdsg": "Einzelheiten",
    "scts": "Sperrtage: ",
    "sy": "verbleibend",
    "ljsg": "Abonniere jetzt",
    "ysk": "Ausverkauft",
    "xzjdy": "Abonniere jetzt",
    "dy": "Abonnieren",
    "fxjg": "Ausgabepreis",
    "fxl": "Verkehr",
    "ssrq": "Angebotsdatum",
    "yxqx": "Gültigkeitszeitraum",
    "qsrsl": "Bitte Betrag eingeben",
    "syl": "verbleibend",
    "sgrq": "Abonnieren",
    "sgsl": "Höhe",
    "bz": "Münze",
    "yebz": "Unzureichendes USDT-Guthaben",
    "tgsl": "Passmenge",
    "shz": "unter Überprüfung",
    "wtg": "Nicht bestanden",
    "ytg": "bestanden"
  },
  "wydb":{
    "title": "Ausleihen",
    "db": "Ausleihen",
    "dbz": "Ausleihen",
    "jl": "aufzeichnen",
    "jdzq": "Zeitraum (Tage)",
    "qhk": "Zurückzahlen",
    "ljdb": "Kumulativ (usdt)",
    "dhkbs" :"Ausstehende Zahlung",
    "jkje": "Kreditbetrag (usdt)",
    "qsrje": "Bitte Betrag eingeben",
    "rll": "Tageszinssatz",
    "hkfs": "Rückzahlung",
    "dqych": "Abgelaufen",
    "lx": "Interesse",
    "fkjg": "Darlehensgeber",
    "tpsc": "Kreditdarlehen (Bild-Upload)",
    "fwxx": "Wohninformationen",
    "srzm": "Einkommensnachweis (Arbeitsverhältnis)",
    "yhmx": "Kontoauszug",
    "zjz": "Ausweisfoto",
    "yd": "Ich habe gelesen und zugestimmt",
    "xy": "Beantragen Sie einen Kreditvertrag",
    "sqdb": "Kreditketten beantragen",
    "gb": "Schließung",
    "qd": "OK",
    "ts": "Bitte überprüfen Sie Kreditvertrag beantragen",
    "dbjl": "aufzeichnen",
    "hkhth": "Bestellcode",
    "wsh": "Ungeprüft",
    "yfk": "Darlehen",
    "sqrq": "Bewerbungszeit",
    "zq": "Kreislauf",
    "dbsl": "Anzahl Rippen",
    "zhke": "Gesamtzahlung",
    "yhkxq": "Rückzahlungsdetails",
    "bqyhk": "Rückzahlbar in der aktuellen Periode(USDT)",
    "hktips": "Bitte stellen Sie sicher, dass das Guthaben ausreicht, wenn das Guthaben nicht ausreicht, laden Sie bitte zuerst auf und zahlen Sie dann zurück",
    "bj": "Rektor",
    "jie": "Ausleihen",
    "ljhk": "Sofort zurückzahlen",
    "qcz": "Deponieren",
    "yebzqxcz": "Unzureichendes Guthaben, bitte zuerst aufladen und dann zurückzahlen",
    "znj": "Gebühr für zu spätes Zahlen",
    "yqts": "Tage überfällig"
  },
  "hkxq":{
    "dd":"Befehl",
    "fzhkdz":"Kopieren Sie die Rückzahlungsadresse",
    "hkxq": "Rückzahlungsdetails",
    "zlx": "Gesamtinteresse",
    "zhk": "Gesamtrückzahlungen",
    "hkjg": "Rückzahlungsstelle",
    "qschkpz": "Bitte laden Sie die Rückzahlungsbescheinigung hoch",
    "hkpz": "Rückzahlungsbescheinigung"
  },
  "bbjyNew":{
    "jylx": "Arten von",
    "jyze": "Menge"
  },
  "bind":{
    "title": "Email",
    "ybd": "Gebunden",
    "wbd": "Ungebunden",
    "ts": "Um Ihr Konto zu schützen, wird empfohlen, eine E-Mail-Adresse zu binden",
    "qsryxdz": "E-Mail-Addresse"
  },
  "tipsNew": {
    "yjj": "abgelehnt",
    "shz": "Erlösung"
  },
  "newIndex2":{
    "zxhy": "Neueste Zitate",
    "jypt": "Handelsplattform",
    "dqwz": "Aktuelle Position",
    "yzm": "Bestätigungscode",
    "qrmm": "Passwort bestätigen",
    "djdl": "Zum Anmelden klicken",
    "ghdjy": "Besseres Angebot",
    "ghdsh": "Besser leben",
    "about": "Das weltweit innovativste Krypto-Tauschzentrum ist hier, wo Sie Kryptowährungen mit Hunderten von Kryptowährungen kaufen, handeln und verdienen können.",
    "index01": "Ihr Tor zu Bitcoin und darüber hinaus",
    "index02": "Die weltweit führende Serviceplattform für digitale Assets",
    "index03": "Alle Transaktionen sind kostenlos",
    "index04": "Kontoeröffnungsgebühr, Kontoführungsgebühr, Stop-Loss-Gebühr, Einzahlungsgebühr, Lager-/Liefergebühr sind alle kostenlos.",
    "index05": "Sichere und geschützte Sicherheit",
    "index06": "Wir nutzen das Know-how, das GMI INT seit seiner Gründung gesammelt hat, bauen robuste Systeme und implementieren verschiedene Sicherheitsmaßnahmen, um die Vermögenswerte unserer Kunden sicher und zuverlässig zu schützen.",
    "index07": "Sowohl physischer Handel als auch gehebelter Handel sind verfügbar",
    "index08": "Kleine Transaktionen können ab etwa 10 $ getätigt werden, der Spread ist der engste in der Branche und der Kontostand kann als Sicherheit für gehebelte Transaktionen verwendet werden. Leverage-Gebühren kann nur GMI INT erheben.",
    "index09": "Tokens, die entwickelt wurden, um die GMI INT-Community zu stärken",
    "index10": "Unus Sed LEO ist ein Anwendungs-Token, das entwickelt wurde, um Benutzern zu helfen, die die Vorteile und Funktionen der GMI INT-Handelsplattform maximieren möchten, um ihre Bedürfnisse zu erfüllen.",
    "index11": "Tokens, die entwickelt wurden, um die GMI INT-Community zu stärken",
    "index12": "Öffne den Weg zu einem besseren Leben",
    "index13": "Jeder kann Krypto besitzen. Jeder kann Krypto-Software handeln. So kann Bitget Sie einen Schritt weiter bringen.",
    "index14": "Innovative Produkte",
    "index15": "Kopieren mit einem Klick",
    "index16": "Beim Handeln keine Token umwandeln",
    "index17": "Große Derivatebörsen, die die USDC-Margin unterstützen",
    "index18": "Risikokontrolle durch Hot- und Cold-Wallet-Isolierung",
    "index19": "12 a+ Bewertungen von SSL Labs",
    "index20": "Vertrauenswürdige Sicherheit, unterstützt von Suntwin Technology, Green Pine Cloud Security, HEAP und Armors",
    "index21": "Exzellenter Kundenservice",
    "index22": "Online-Support rund um die Uhr in mehreren Sprachen",
    "index23": "Eins-zu-Eins-Support für VIP-Kunden",
    "index24": "Community-Belohnungszentrum",
    "index25": "Erstellt von Händlern für Händler",
    "index26": "Handel mit verschiedenen digitalen Vermögenswerten wie Bitcoin, Ethereum, Solana und Dogcoin mit geringen Transaktionskosten",
    "index27": "Die Tools und Informationen, die Sie zum Kaufen, Verkaufen, Handeln, Investieren und Verwenden von Kryptowährungen benötigen",
    "index28": "Branchenführende Sicherheit",
  },
  "langNew":{
    "szhb": "Kryptowährung",
    "gjs": "Metall",
    "yy": "Roh",
    "jy": "Handeln",
    "jmhb": "Kryptowährung",
    "yxhy": "Unbefristeter Vertrag",
    "gdjy": "Ausstehende Bestellung",
    "khh": "Bankkonto",
    "qsrkhh": "Bitte geben Sie die Bank ein",
    "yhkh": "Bankkontonummer",
    "qsryhkh": "Bitte Bankkontonummer eingeben",
   }
}



// WEBPACK FOOTER //
// ./src/lang/de.js